import Joi from "joi";

const requiredRedReceiptNumber = Joi.string().required().messages({
  "string.empty": "Harap pilih No. bon merah",
  "any.required": "Harap pilih No. bon merah",
});

const schema = Joi.object({
  employeeNip: Joi.string().required(),
  employeeName: Joi.string().required(),
  jobId: Joi.number().required(),
  jobTitle: Joi.string().required(),
  codeType: Joi.object({
    label: Joi.string(),
    value: Joi.string(),
    checked: Joi.any(),
  }),
  area: Joi.object({
    label: Joi.string(),
    value: Joi.string(),
    checked: Joi.any(),
  }),
  pool: Joi.object({
    label: Joi.string(),
    value: Joi.string(),
    checked: Joi.any(),
  }),
  segment: Joi.object({
    label: Joi.string(),
    value: Joi.string(),
    checked: Joi.any(),
  }).required().messages({
    "any.required": "Harap pilih Segment",
  }),
  department: Joi.string().required().messages({
    "any.required": "Harap pilih Departemen",
  }),
  company: Joi.object({
    label: Joi.string(),
    value: Joi.string().messages({
      "string.empty": "Harap pilih Perusahaan",
    }),
    checked: Joi.any(),
  }).required().messages({
    "any.required": "Harap pilih Perusahaan",
  }),
  companyRelation: Joi.any().when("company.label", {
    switch: [
      {
        is: "KBBO",
        then: Joi.object({
          label: Joi.string(),
          value: Joi.string(),
          checked: Joi.any(),
        }).required().messages({
          "any.required": "Harap isi Perusahaan relasi",
        }),
      },
    ],
  }),
  trxType: Joi.object({
    label: Joi.string(),
    value: Joi.string(),
    checked: Joi.any(),
  }).required().messages({
    "any.required": "Harap pilih Tipe transaksi",
  }),
  redReceiptType: Joi.any().when("trxType.value", {
    switch: [
      {
        is: "BMH",
        then: Joi.object({
          label: Joi.string(),
          value: Joi.string(),
          checked: Joi.any(),
        }).required().messages({
          "any.required": "Harap pilih Tipe bon merah",
        }),
      },
    ],
  }),
  redReceiptNumber: Joi.any().when("trxType.value", {
    switch: [
      {
        is: "BKI",
        then: requiredRedReceiptNumber,
      },
      {
        is: "BKS",
        then: requiredRedReceiptNumber,
      },
    ],
  }),
  amount: Joi.string().required().messages({
    "string.empty": "Harap isi Total bon",
    "any.required": "Harap isi Total bon",
  }),
  planPostDate: Joi.string().required().messages({
    "any.required": "Harap isi Estimasi tanggal kirim",
  }),
  trxCode: Joi.string().required().messages({
    "string.empty": "Harap pilih Akun GL",
    "any.required": "Harap pilih Akun GL",
  }),
  beneficiaryCode: Joi.string().required().messages({
    "string.empty": "Harap pilih Rekening tujuan",
    "any.required": "Harap pilih Rekening tujuan",
  }),
  description: Joi.string().required().messages({
    "any.required": "Harap isi Deskripsi",
  }),
});

export default schema;
